import { c as _c } from "react/compiler-runtime";
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useNavigationOverride } from '@/idv2/features/app-shell';
import CollectDocument from '@/idv2/features/collect-document';
import type { IdDocOutcome } from '@/idv2/features/collect-document/types';
import { setExternalBack } from '@/idv2/features/idv-to-idv2';
import { useFootprint } from '@/idv2/hooks/use-footprint';
import getDevice from '@/idv2/utils/get-device';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'collect-document-route'
});
export const Route = createFileRoute('/onboarding/$token/collect-document')({
  component: CollectDocumentPage,
  beforeLoad: async ({
    context: {
      currentRequirement,
      config,
      idDocOutcome
    }
  }) => {
    if (currentRequirement?.kind !== 'collect_document') {
      throw new Error(`Collect document loader invalid requirement kind: ${currentRequirement?.kind ?? 'unknown'}`);
    }
    logInfo('Collect document beforeLoad started', {
      requirementKind: currentRequirement.kind
    });
    const deviceInfo = await getDevice();
    return {
      deviceInfo,
      config,
      idDocOutcome
    };
  },
  loader: ({
    context: {
      deviceInfo,
      config,
      idDocOutcome,
      currentRequirement
    }
  }) => {
    logInfo('Collect document loader started');
    return {
      deviceInfo,
      config,
      idDocOutcome,
      currentRequirement
    };
  }
});
function CollectDocumentPage() {
  const $ = _c(10);
  const {
    deviceInfo,
    config,
    idDocOutcome,
    currentRequirement
  } = Route.useLoaderData();
  const {
    token
  } = Route.useParams();
  const {
    navigation
  } = useFootprint();
  const {
    setNavigationOverridden
  } = useNavigationOverride();
  let t0;
  let t1;
  if ($[0] !== setNavigationOverridden) {
    t0 = () => {
      setNavigationOverridden(true);
      setExternalBack(undefined);
      return () => setNavigationOverridden(false);
    };
    t1 = [setNavigationOverridden];
    $[0] = setNavigationOverridden;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = idDocOutcome as IdDocOutcome | undefined;
  let t3;
  if ($[3] !== config || $[4] !== currentRequirement || $[5] !== deviceInfo || $[6] !== navigation.forward || $[7] !== t2 || $[8] !== token) {
    t3 = <CollectDocument authToken={token} device={deviceInfo} requirement={currentRequirement} onboardingConfig={config} sandboxOutcome={t2} onDone={navigation.forward} />;
    $[3] = config;
    $[4] = currentRequirement;
    $[5] = deviceInfo;
    $[6] = navigation.forward;
    $[7] = t2;
    $[8] = token;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}